import React from 'react'
import PropTypes from 'prop-types'
import { AVAILABLE_BRANDS } from 'styles/theme'
import { useTheme } from 'styled-components'
import Background from 'components/atoms/Background'
import * as S from './styled'

const Layout2 = ({ content: poster }) => {
  const { color } = useTheme()
  if (color === AVAILABLE_BRANDS.CLOUD_DARK) {
    return (
      <S.Container>
        <Background illustration={poster.ilustration} />
        <S.TextBlock>
          <p>{poster.text}</p>
          <p className='title'>{poster.title}</p>
        </S.TextBlock>
      </S.Container>
    )
  }
}

Layout2.defaultProps = {
  content: {},
}

Layout2.propTypes = {
  content: PropTypes.object,
}

export default Layout2
